let regex: RegExp = new RegExp(/^-?\d*$/g);

export function pasteNumberOnly(event) {
  let clipboardData = event.clipboardData || window['clipboardData'];
  let pastedText = clipboardData.getData('text');

  if (pastedText && !regex.test(pastedText)) {
    event.preventDefault();
  }
}
